export const displaySpeed = (speed) => {
    speed = parseFloat(speed);

    // for gig, take the speed / 1000 to handle any possible combinations like 2000, 1250, etc.
    let displaySpeed = speed >= 1000 ? speed / 1000 : speed;
    let unit = speed >= 1000 ? 'Gig' : 'Mbps';
    let text = `${displaySpeed} ${unit}`;

    return {
        speed: displaySpeed,//.toString(),
        unit,
        text,
    };

    /*
    if(speed >= 1000) {
        return `${speed / 1000} Gig`;
    }

    return `${speed} MBPS`;
    */
}

export const displayCost = (cost, includeMo = true, displayFree = true, freeText = 'FREE') => {
    cost = parseFloat(cost).toFixed(2);
    if(parseFloat(cost) === 0 && displayFree) return freeText;

    if(cost <= 0) return `-\$${Math.abs(cost).toFixed(2)}${includeMo && '/mo'}`;

    return `\$${cost}${includeMo && '/mo'}`;
};